import { AxiosError } from 'axios';

export const MENSAGEM_SERVICO_INDISPONIVEL =
  'O serviço está temporariamente indisponível. Tente novamente em instantes.';

// Um 503 aqui pode ser o TokenAuthGuard sinalizando que não deu pra confirmar a sessão
// (yggdrasil indisponível), mas também pode ser o cms-api ou o gateway na frente dele caindo
// por outro motivo (deploy, pod reiniciando) — por isso a mensagem é genérica, não assume a
// causa. Reescreve tanto `message` quanto `response.data.message`: os formulários do cms-web
// exibem `err?.response?.data?.message || err?.message`, então só trocar `message` não chega
// à tela.
export function tratarIndisponibilidade(error: AxiosError): Promise<never> {
  if (error?.response?.status === 503) {
    // eslint-disable-next-line no-param-reassign
    error.message = MENSAGEM_SERVICO_INDISPONIVEL;

    const corpo = error.response.data as { message?: string } | undefined;
    if (corpo && typeof corpo === 'object') {
      corpo.message = MENSAGEM_SERVICO_INDISPONIVEL;
    }
  }
  return Promise.reject(error);
}
